import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

import Card from './Card'
import * as tutorialActions from '../../tutorial.actions'
import * as tutorialSelectors from '../../../Tutorial/tutorial.selectors'

/**
 *  Pop up showed when you have finished the game
 */
class TutorialMiningSelectContainer extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      showInfo: false,
    }
  }

  closeMine() {
    const { phase, goTo, removeScreen } = this.props
    if (phase == 2) {
      goTo({
        phase: 3,
      })
    } else if (phase == 3) {
      removeScreen('mining_screen')
    }
  }

  renderAnswerQuestion() {
    const {
      miningUI,
      changeMiningScreen,
      counters: { an_xt: answers_by_turn, an_t: turn_answers },
      answerPrizeCoins,
      isAnswerPenalized,
    } = this.props
    const { showInfo } = this.state

    let infoTooltip = 'tooltips.answer_question'
    return (
      <Card
        changeScreen={() => changeMiningScreen('answer_question_screen')}
        signalNameId="mining.answer_question"
        count_current={answers_by_turn - turn_answers}
        count_total={answers_by_turn}
        penalized={isAnswerPenalized}
        prizeCoins={answerPrizeCoins}
        infoTooltip={infoTooltip}
        tooltipValue=""
        showInfo={showInfo}
        icon="icon-answer"
        hide={!miningUI.answer}
      />
    )
  }

  renderCreateQuestion() {
    const {
      changeMiningScreen,
      counters: { qu_xt: questions_by_turn, qu_t: turn_questions },
      isCreatePenalized,
      createPrizeCoins,
      miningUI,
    } = this.props
    const { showInfo } = this.state
    const topic = ' Mars Academy'
    let infoTooltip = 'tooltips.create_question'
    return (
      <Card
        changeScreen={() => changeMiningScreen('create_question_screen')}
        signalNameId="mining.create_question"
        count_current={questions_by_turn - turn_questions}
        count_total={questions_by_turn}
        penalized={isCreatePenalized}
        prizeCoins={createPrizeCoins}
        infoTooltip={infoTooltip}
        tooltipValue={topic}
        showInfo={showInfo}
        icon="icon-question"
        hide={!miningUI.create}
      />
    )
  }

  renderDebateQuestion() {
    const { changeMiningScreen, debatePrizeCoins, countDisputes, miningUI } = this.props
    const { showInfo } = this.state

    const topic = ' Mars Academy'
    const infoTooltip = 'tooltips.debate_question'
    return (
      <Card
        changeScreen={() => changeMiningScreen('vote_question_screen')}
        signalNameId="mining.vote_question"
        count_current={0}
        count_total={1}
        prizeCoins={debatePrizeCoins}
        infoTooltip={infoTooltip}
        tooltipValue={topic}
        countDisputes={countDisputes}
        showInfo={showInfo}
        icon="icon-debate"
        hide={!miningUI.dispute}
      />
    )
  }

  renderMiningFinished() {
    const { phase } = this.props

    return (
      <div className="btn--orange" onClick={() => this.closeMine()}>
        <span className="icon-rocket"> </span>
        <FormattedMessage id={phase == 2 ? 'mining.goFase3' : 'mining.back'} />
      </div>
    )
  }

  render() {
    const {
      counters: { qu_t: turn_questions, an_t: turn_answers },
      miningUI,
    } = this.props
    const showInfo = () => {
      const showInfo = !this.state.showInfo
      this.setState({ showInfo })
    }

    const canGoNextPhase = turn_questions === 0 && turn_answers === 0
    return (
      <div className="mina--layer vertical--center">
        <div className="signals--waves">
          <div className="signal-1"></div>
        </div>
        <div className="signal--title">
          <span>
            <FormattedMessage id="mining.title" />
          </span>
          <span className="signal--subtitle">
            <FormattedMessage id="mining.earnGCoins" />
          </span>
        </div>
        {miningUI.displayInfo && (
          <div className="signal--get">
            <div className="btn" onClick={showInfo}>
              <div className="btn--primary">
                <span className="icon-information"> </span>
              </div>
            </div>
          </div>
        )}
        <div className="signals--list">
          {this.renderCreateQuestion()}
          {this.renderAnswerQuestion()}
          {this.renderDebateQuestion()}
        </div>
        {miningUI.nextTurnButton && canGoNextPhase && this.renderMiningFinished()}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  addScreen: bindActionCreators(tutorialActions.addScreen, dispatch),
  removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
  goTo: bindActionCreators(tutorialActions.goTo, dispatch),
  changeMiningScreen: bindActionCreators(tutorialActions.changeMiningScreen, dispatch),
})

const mapStateToProps = (state) => ({
  createPrizeCoins: tutorialSelectors.getPrizeCoins(state),
  isAnswerPenalized: false,
  isCreatePenalized: false,

  debatePrizeCoins: tutorialSelectors.getPrizeCoins(state),
  counters: tutorialSelectors.getCountersData(state),
  phase: tutorialSelectors.getCurrentPhase(state),
  answerPrizeCoins: tutorialSelectors.getPrizeCoins(state),
  miningUI: tutorialSelectors.getMiningUI(state),
  countDisputes: tutorialSelectors.getTotalDisputes(state),
})

TutorialMiningSelectContainer.propTypes = {
  changeMiningScreen: PropTypes.func,
  goTo: PropTypes.func,
  countDisputes: PropTypes.number,
  counters: PropTypes.object,
  answerPrizeCoins: PropTypes.number,
  phase: PropTypes.number,
  createPrizeCoins: PropTypes.number,
  debatePrizeCoins: PropTypes.number,
  isAnswerPenalized: PropTypes.bool,
  isCreatePenalized: PropTypes.bool,
  miningUI: PropTypes.object,
  removeScreen: PropTypes.func,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(TutorialMiningSelectContainer))
